import React, { useState } from "react";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../Loader";
import { showRegister, searsh_product } from "../Redux/HomeSlice";
import { useNavigate } from "react-router-dom";
import Register from "../Register/Register";
import {
  product_reviews,
  product_details,
  favorites,
  addFavorite,
  remove_favorites,
} from "../Redux/API";
import { useTranslation } from "react-i18next";
import "../Offers/Offers.css";
import { useEffect } from "react";

function Searsh() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();


  const showR = useSelector((state) => state?.products?.showR);

  const favorite = useSelector((state) => state?.Data?.favorites?.data?.data);
  const loadingRemove_favorites = useSelector((state) => state.Data.loadingRemove_favorites);
  const loadingAddFavorite = useSelector((state) => state.Data.loadingAddFavorite);
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });

  const getLocalStorage = window.localStorage.getItem("UserInfo");
  const valueLocalStorage = getLocalStorage
    ? JSON.parse(getLocalStorage)
    : null;
  const token =
    valueLocalStorage?.data?.token ||
    valueLocalStorage?.data?.data?.user?.token ||
    null;

  useEffect(() => {
    if (!loadingAddFavorite && !loadingRemove_favorites) {
      dispatch(favorites());
    }
  }, [dispatch, loadingAddFavorite, loadingRemove_favorites]);

  const handelAdd_wishlist = (id, event) => {
    if (token) {
      const isInWishlist = favorite?.some((item) => item.product_id === id);
      if (isInWishlist) {
        dispatch(remove_favorites(id));
      } else {
        dispatch(addFavorite({ id }));
      }
    } else {
      const { pageY } = event;
      const offsetY = -100; 
      setPopupPosition({ x: 50, y: pageY + offsetY }); 
    }
  };

  const gotoProductDetails = (id) => {
    localStorage.setItem("Product_id", id);

    dispatch(product_details(id));
    dispatch(product_reviews(id));
    window.scrollTo(0, 0);
    navigate("/Product");
    dispatch(searsh_product(false));

  };

  const loadingSearsh_brand = useSelector(
    (state) => state.Data.loadingSearsh_brand
  );
  const searsh = useSelector((state) => state.Data.searsh_brand);

  return (
    <>
    {showR && (
        <div className="overlay">
            <div
              className="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-4 mx-auto g-0"
              style={{
                position: "absolute",
                top: `${popupPosition.y}px`,
                left: "50%",
                transform: "translateX(-50%)",
                margin: "auto",
                zIndex: 4,
                padding: "0px",
              }}
            >
              <Register />
            </div>
          </div>
        )}
    <div className="searsh_product">
          {loadingSearsh_brand && <Loader />}
        <div className="container">
            <div className="cont row justify-content-between g-0 border-0 ">
              <div className=" col">
                <div className="gallery1 container 0 border-0 mt-2">
                  <div className="row_prodect row  align-items-center justify-content-around g-0 border-0">
                    {searsh?.data?.data.map((product, index) => {
                      const isInWishlist = favorite?.some(
                        (item) => item.product_id === product.id
                      );

                      return (
                        <div
                          key={index}
                          className="box col-5 col-sm-4 px-sm-2 col-md-4 px-md-3 col-lg-3 px-lg-3 mx-lg-0 col-xl-2 mx-xl-1 px-xl-0 text-center g-0 mb-3"
                        >
                          <div className="border_box">
                            <div className="padding_box"onClick={() => gotoProductDetails(product.id)} >
                              <i
                                className="font-size2"
                                onClick={(event) => {
                                  handelAdd_wishlist(product.id, event);
                                  event.stopPropagation();
          
                                }}
                                style={{
                                  color: isInWishlist ? "red" : "white",
                                }}
                              >
                                <FontAwesomeIcon icon={faHeart} />
                              </i>
                              {product?.discount && (
                                <p className="discount">
                                  Off {product?.discount}
                                </p>
                              )}
                              <img
                                src={product.main_image}
                                alt={`img-${index}`}
                              />
                              <span className="discraptoin mb-4 product_name ">
                                {product?.name}
                              </span>
                              <p className="discraptoin discraptoin_name">
                                {product?.type?.name}
                              </p>
                              <div className="price align-items-center">
                                <p>{product?.new_price}</p>
                                {product?.old_price && (
                                  <p className="old_price">
                                    {product?.old_price}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </>
    );
}

export default Searsh;
